import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-signup-prevent",
    templateUrl: "./signup-prevent.component.html",
    styleUrls: ["./signup-prevent.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class SignupPreventComponent {
  constructor(
    public translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private matDialog: MatDialog
  ) {
    try {
      this.authService?.selectedlanguage$?.subscribe(
        (l) => {
          translate.use(l ? l : "en");
        },
        (err) => {
          return err;
        }
      );
    } catch (err) {
      return err;
    }
  }

  signInPage() {
    this.matDialog.closeAll();
    this.router.navigateByUrl("login");
  }
}
